import { ImageNumber } from './common/ImageNumber';
import { SimpleButton } from './common/SimpleButton';
import { GameQuizResources } from './GameQuizResources';
import { GameView } from "./common/GameView";
import { GameQuizMain } from './GameQuizMain';

export class GameQuizTitleView extends GameView {

    protected startButton_a: SimpleButton;
    protected startButton_b: SimpleButton;

    protected pictureBookButton: SimpleButton;
    protected howtoButton: SimpleButton;
    protected nicknameButton: SimpleButton;
    protected rankingButton: SimpleButton;
    protected backButton: SimpleButton;

    static eventTagStartGame: string = "menu_start";
    static eventTagRanking: string = "menu_anking";
    static eventTagBack: string = "menu_back";
    static eventTagPictureBook: string = "manu_picture_book";
    static eventTagNickname: string = "menu_nickname";
    static eventTagHowTo: string = "menu_howto";

    static eventTagStart: string = "start_clicked";
    protected resources: GameQuizResources;
    constructor(width: number, height: number, resources: GameQuizResources) {
        super(width, height);
        this.resources = resources;
    }
    protected number: ImageNumber;
    protected result: Number;

    private titleImage: createjs.Sprite;
    public selectGame = 0;

    async initClass(): Promise<void> {
        //背景
        this.addChild(this.resources.get_background());

        this.titleImage = this.resources.get_title_title();
        this.titleImage.x = (this.width/2)-(this.resources.get_title_title().getBounds().width/2);
        this.titleImage.y = 0;
        this.addChild(this.titleImage);

        const btnYStart = 740;
        const btnYSpan = 120;
        const btnXSpan = 0;

        // スタートボタン
        this.startButton_a = new SimpleButton(
            this.resources.get_title_btn_start_a(),
            this.resources.get_title_btn_start_a(),
            this.resources.get_title_btn_start_a(),
            this.resources.get_title_btn_start_a()
        );
        this.startButton_a.x = (this.width - this.resources.get_title_btn_start_a().getBounds().width) / 2 - btnXSpan;
        this.startButton_a.y = btnYStart+btnYSpan;
        this.addChild(this.startButton_a);
        this.startButton_a.setFunc('click', () => {
            this.startButton_a.disable();
            this.startButton_b.disable();
            this.selectGame = GameQuizMain.SELECT_GAMETYPE_ONCE;
            this.dispatchEvent(new createjs.Event(GameQuizTitleView.eventTagStartGame, true, false));
        })

        // スタートボタン
        this.startButton_b = new SimpleButton(
            this.resources.get_title_btn_start_b(),
            this.resources.get_title_btn_start_b(),
            this.resources.get_title_btn_start_b(),
            this.resources.get_title_btn_start_b()
        );
        this.startButton_b.x = (this.width - this.resources.get_title_btn_start_b().getBounds().width) / 2 - btnXSpan;
        this.startButton_b.y = btnYStart+(btnYSpan*2);
        this.addChild(this.startButton_b);
        this.startButton_b.setFunc('click', () => {
            this.startButton_a.disable();
            this.startButton_b.disable();
            this.selectGame = GameQuizMain.SELECT_GAMETYPE_FAMILY;
            this.dispatchEvent(new createjs.Event(GameQuizTitleView.eventTagStartGame, true, false));
        })
    }

    protected async createScenes(): Promise<void> {

    }

    async initScenes(): Promise<void> {
        this.startButton_a.enable();
        this.startButton_b.enable();
    }

}
